class AboDisplay {
  constructor() {
    this.inited = false;
    this.pagedatas = Object.assign({
      "pagetype" : null,
      "contentname": null,
      "contentobjectid": null,
      "contentclassid": null,
      "contentclassidentifier": null,
      "tagids": [],
      "pathstring": null,
      "url": null,
    }, ( document.body.dataset.pagedatas? JSON.parse( document.body.dataset.pagedatas ) : {} ) );
    this.possibleblocs = {};
  }

  async fillmarkettingbloccontainers( userinfos, userroles ){
    let AboDisplay = this;
    let pagedatas = AboDisplay.pagedatas;
    let possibleblocs = AboDisplay.possibleblocs;
    
    userroles.loggedin =  userinfos.loggedin;

    const markettingbloccontainers = document.getElementsByClassName("markettingbloc-dynamic-container");
    if( markettingbloccontainers != null ){
      for (let i = 0; i < markettingbloccontainers.length; i++) {
        let markettingbloccontainer = markettingbloccontainers[i];
        if( markettingbloccontainer.dataset.typebloc ){
          let typebloc = markettingbloccontainer.dataset.typebloc;

          /* Types de blocs non dispo sur les publis */
          if( [ 'toaster','bottombanner','popin' ].includes(typebloc) && [ 'frontpage_ops','publi' ].includes(pagedatas.contentclassidentifier ) ){
            return;
          }

          // get first abo bloc from possible blocs
          if( typeof possibleblocs[typebloc] !== 'undefined' && possibleblocs[typebloc].length )
          {
            for ( const [i, possiblebloc] of Object.entries(possibleblocs[typebloc] ) )
            {
              /* On exclu les blocs déjà fermés */
              if( sessionStorage.getItem("abodisplay-closed-"+ typebloc +'-'+ possiblebloc.campaignid) ){
                console.log( 'bloc '+ typebloc +'-'+ possiblebloc.campaignid + ' excluded by closed');
                continue;
              }

              let target = ( typeof possiblebloc.target === 'object' && possiblebloc.target !== null )? possiblebloc.target : {};

              /* On filtre par classe de contenu */
              if( typeof target.contentclassids !== 'undefined' && target.contentclassids != null && target.contentclassids.length && !target.contentclassids.includes( pagedatas.contentclassid.toString() ) )
              {
                console.log( 'bloc '+ typebloc +'-'+ possiblebloc.campaignid + ' excluded by contentclassids');
                continue;
              }

              /* On filtre sur le status premium */
              if( typeof target.excludepremium !== 'undefined' && target.excludepremium != null && target.excludepremium && pagedatas.premium  == 1 )
              {
                console.log( 'bloc '+ typebloc +'-'+ possiblebloc.campaignid + ' excluded by excludepremium');
                continue;
              }

              /* On filtre par arborescence */
              if( typeof target.contentobjectids !== 'undefined' && target.contentobjectids != null && target.contentobjectids.length )
              {
                let pathstring = pagedatas.pathstring.replace(/^\//,'').replace(/\/$/,'');
                let intersect = pathstring.split('/').filter( value => target.contentobjectids.includes(value));
                if( !intersect.length && !target.contentobjectids.includes( pagedatas.contentobjectid.toString() ) )
                {
                  console.log( 'bloc '+ typebloc +'-'+ possiblebloc.campaignid + ' excluded by contentobjectids');
                  continue;
                }
              }
              
              /* On filtre par tag */
              if( typeof target.tagids !== 'undefined' && target.tagids != null && target.tagids.length )
              {
                let intersect = pagedatas.tagids.filter( value => target.tagids.includes(value.toString()));
                if( !intersect.length )
                {
                  console.log( 'bloc '+ typebloc +'-'+ possiblebloc.campaignid + ' excluded by tagids');
                  continue;
                }
              }
  
              /* On filtre par roles */
              if( typeof target.rolefilter !== 'undefined' && target.rolefilter != null && target.rolefilter != 'all' && typeof target.roles !== 'undefined' && target.roles != null && target.roles.length )
              {
                let escapethisbloc = false;
                for ( const [i, role] of Object.entries(target.roles) ){
                  if( typeof userroles[role] !== 'undefined' && ( ( userroles[role] == false && target.rolefilter == 'include' ) || ( userroles[role] == true && target.rolefilter == 'exclude' ) ) ){
                   
                    escapethisbloc = true;
                  }
                }
                if( escapethisbloc ){
                  console.log( 'bloc '+ typebloc +'-'+ possiblebloc.campaignid + ' excluded by rolefilter');
                  continue;
                }
              }

              markettingbloccontainer.innerHTML = possiblebloc.html;

              if( typebloc  == 'toaster' ) {
                AboDisplay.loadToaster(typebloc);
              } else if( typebloc == 'popin' ) {
                AboDisplay.loadPopin( markettingbloccontainer, possiblebloc, typebloc );
              }
              else {
                if( possiblebloc.qualifioscript != '')
                {
                  let script = document.createElement("script");
                  script.type = "text/javascript";
                  script.appendChild(document.createTextNode(possiblebloc.qualifioscript));
                  markettingbloccontainer.appendChild(script);
                }
              }
  
              [... markettingbloccontainer.querySelectorAll('.markettingbloc-close')].map( closelink => {
                closelink.addEventListener('click', (e) => {
                  markettingbloccontainer.remove();
                  sessionStorage.setItem( "abodisplay-closed-"+ typebloc +'-'+ possiblebloc.campaignid, 1 );
                });
              });
              break;
            }
          }
        }
      }
    }
  }

  async loadPopin( markettingbloccontainer, bloc, typebloc ){
    console.log( 'Abodisplay : loadPopin' );
    
    let url = new URL(window.location.href);
    if( url.pathname == '/compte/inscription' || url.pathname == '/compte/loginsuccess' || url.pathname == "/compte/mes-informations" || url.pathname == "/compte/mes-newsletters" || url.pathname == "/compte/modifier-mon-mot-de-passe" || url.pathname == "/compte/mes-abonnements" || url.pathname == '/compte/espace-abonnes' || url.pathname == '/mes-avantages' )
    {
      return false;
    }

    let sessionPageCount = sessionStorage.getItem('count_session_page')?? 1;
    let popin = document.querySelector('.markettingbloc-popin');
    if( popin && sessionPageCount%3 == 0 )
    {
      popin.style.display = 'block';
      if( bloc.qualifioscript != '')
      {
        let script = document.createElement("script");
        script.type = "text/javascript";
        script.appendChild(document.createTextNode(bloc.qualifioscript));
        markettingbloccontainer.appendChild(script);
      }
    }
  }

  async loadToaster( typebloc ){
    console.log( 'Abodisplay : loadToaster' );
    if( window.innerWidth > 992 )
    {
       setTimeout( function(){
         let elt = document.querySelector(".markettingbloc-toaster");
         if( elt ){
          elt.style.transform = 'translateX(500px)';
          elt.style.display = "block";
          let x = 500;
          let toasterInterval = setInterval(() => {
            if( x >= 0){
              elt.style.transform = 'translateX('+x+'px)';
              x -= 10;
            } else {
              clearInterval( toasterInterval );
            }
          }, 10);
        }
       }, 2000);
    }
  }

  async init( userinfos, userroles ){
    console.log( 'Abodisplay : init', userinfos, userroles );
    let AboDisplay = this;
    if( !AboDisplay.inited ){
      AboDisplay.inited = true;
      //pages count
      let count_page = sessionStorage.getItem( 'count_session_page' )?? 0;
      sessionStorage.setItem('count_session_page', ( count_page + 1 ) );

      let params = new URLSearchParams(document.location.search);
      let campaignid = params.get("mktcampaign");
      let abojsonurl = '/abonnement/list-bloc-abo.json';
      if( campaignid ){
        abojsonurl = '/abonnement/bloc-abo-'+campaignid+'.json';
        //clear session storage abo
        var keys = Object.keys(sessionStorage);
        keys.forEach( key => {
          if( key.includes( 'abodisplay') ){
            sessionStorage.removeItem( key );
          }
        });
      }
      console.log( 'Abodisplay : using url "'+abojsonurl+'"' );
      return new Promise((resolve, reject) => {
        return fetch( abojsonurl, {
          cache: "no-store",
          method: "GET",
          credentials:"omit",
          headers: {
            "Content-Type": "application/json"
          }
        }).then( (response) => {
          return response.json();
        }).then( (abodatas) => {
          AboDisplay.possibleblocs = abodatas;
          AboDisplay.fillmarkettingbloccontainers( userinfos, userroles );
          resolve();
        }).catch( () => {
          reject( 'Erreur lors de l\'envoi de demande des blocs abo' );
        });
      });
    }
  }
}

currentuser.onUserLoad( (e) => {
  let abodisplay = new AboDisplay();
  abodisplay.init( e.detail.userinfos, e.detail.roles );
});